<template>
  <multiselect
    v-model="defaultValue"
    :options="actions"
    track-by="name"
    label="name"
    :multiple="false"
    :allowEmpty="!!allowEmpty"
    :reset-after="true"
    placeholder="Acciones en lote"
    selectedLabel=""
    selectLabel=""
    deselectLabel=""
    @select="dispatchAction"
  ></multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "ConsignmentActionSelector",
    components: {
        Multiselect
    },
    props: {
        allowEmpty: Boolean,
        selectedConsignmentsIds: Array,
        allowConsignmentActions: Array,
        consignmentIssuePermission: Boolean,
        consignmentPostPermission: Boolean,
        consignmentDeletePermission: Boolean,
        bankReturn: Boolean
    },
    data: function () {
        let actions = [
            { name: 'Seleccionar remesas visibles' },
            { name: 'Deseleccionar todas', $isDisabled: true },
            { name: 'Remesar', $isDisabled: true },
            { name: 'Contabilizar', $isDisabled: true },
            { name: 'Eliminar', $isDisabled: true },
            { name: 'Descargar SEPAs', $isDisabled: true },
            { name: 'Descargar Asientos', $isDisabled: true }
        ]
        if (this.bankReturn) {
            actions = [
                { name: 'Seleccionar devoluciones visibles' },
                { name: 'Deseleccionar todas', $isDisabled: true },
                { name: 'Descargar Asientos', $isDisabled: false }
            ]
        }
        return {
            defaultValue: null,
            actions
        }
    },
    methods: {
        dispatchAction (action) {
            this.$emit('selected-action', action.name);
        }
    },
    watch: {
        selectedConsignmentsIds: function() {
            
            if (this.bankReturn) {
                console.log("...........", this.allowConsignmentActions['download_seats'])
                this.actions[1].$isDisabled = ( this.selectedConsignmentsIds.length == 0 );
                this.actions[2].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.allowConsignmentActions['download_seats'] == true );
            } else {
               
                console.log("...........", this.allowConsignmentActions['download_seats'])

                this.actions[1].$isDisabled = ( this.selectedConsignmentsIds.length == 0 );
                this.actions[2].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.consignmentIssuePermission && this.allowConsignmentActions['issue'] == true );
                this.actions[3].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.consignmentPostPermission && this.allowConsignmentActions['post'] == true );
                this.actions[4].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.consignmentDeletePermission && this.allowConsignmentActions['delete'] == true );
                this.actions[5].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.allowConsignmentActions['download_sepa'] == true );
                this.actions[6].$isDisabled = !( this.selectedConsignmentsIds.length > 0 && this.allowConsignmentActions['download_seats'] == true );
            }
        }
    }
}
</script>

<style scoped></style>
